import MetricChartWidget from './metric.widget';
import { metricWidgetSettings } from './widget-settings';
export default MetricChartWidget;
export { metricWidgetSettings };
